/**
 * A post-login redirect target, or null when it is not a plain path on this site.
 *
 * `?redirect=` comes from the URL, so anyone can craft it. Starting with "/" is not enough: browsers
 * and React Router below 7.18 (GHSA-wrjc-x8rr-h8h6) treat "/\evil.com" like "//evil.com", a
 * protocol-relative URL to another site. So a link to /login?redirect=/\evil.com would send a user to
 * an attacker's page straight after a real sign-in. Only a single leading "/" followed by a normal
 * path character passes, and no backslash or control character anywhere.
 */
export function safeInternalPath(target: string | null | undefined): string | null {
  if (!target) return null;
  if (!target.startsWith('/')) return null;
  if (target.startsWith('//')) return null;
  for (let i = 0; i < target.length; i++) {
    const code = target.charCodeAt(i);
    // 92 = backslash; below 32 and 127 = control characters.
    if (code === 92 || code < 32 || code === 127) return null;
  }
  return target;
}
